import { connect } from 'react-redux';
import { StoreState } from '../../../reducers';

import EditPanel from '../../../components/Editor/EditPanel';

const mapStateToProps = (state: StoreState) => {
	const { editor: { editPanel: { x, y } } } = state;
	return {
		x,
		y,
	};
};

export default connect(mapStateToProps)(EditPanel);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/Editor/EditPanel/index.tsx